function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#0F63F2",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 11,
  y1: 14.4,
  x2: 64,
  y2: 14.4
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 76,
  y1: 138.4,
  x2: 87,
  y2: 138.4
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 11.3,
  y1: 23.6,
  x2: 87,
  y2: 23.6
});

var _ref5 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 11.3,
  y1: 28.6,
  x2: 87,
  y2: 28.6
});

var _ref6 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 11.3,
  y1: 33.6,
  x2: 23,
  y2: 33.6
});

var _ref7 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 11.3,
  y1: 76.6,
  x2: 23,
  y2: 76.6
});

var _ref8 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 11.3,
  y1: 43.6,
  x2: 87,
  y2: 43.6
});

var _ref9 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 11.3,
  y1: 48.6,
  x2: 87,
  y2: 48.6
});

var _ref10 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 11.3,
  y1: 53.6,
  x2: 87,
  y2: 53.6
});

var _ref11 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 11.3,
  y1: 58.6,
  x2: 87,
  y2: 58.6
});

var _ref12 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 11.3,
  y1: 63.6,
  x2: 69,
  y2: 63.6
});

var _ref13 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 11.3,
  y1: 87.6,
  x2: 87,
  y2: 87.6
});

var _ref14 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 11.3,
  y1: 92.6,
  x2: 87,
  y2: 92.6
});

var _ref15 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 11.3,
  y1: 97.6,
  x2: 87,
  y2: 97.6
});

var _ref16 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 11.3,
  y1: 102.6,
  x2: 51,
  y2: 102.6
});

var _ref17 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 11.3,
  y1: 111.6,
  x2: 87,
  y2: 111.6
});

var _ref18 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 11.3,
  y1: 116.6,
  x2: 87,
  y2: 116.6
});

var _ref19 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 11.3,
  y1: 121.6,
  x2: 87,
  y2: 121.6
});

var _ref20 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 11.3,
  y1: 126.6,
  x2: 87,
  y2: 126.6
});

var SvgDocument = function SvgDocument(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 150",
    overflow: "visible",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDocument, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/document.e0f717f5.svg";
export { ForwardRef as ReactComponent };